import React, { useEffect} from "react";
import dayjs from "dayjs";
import { Table  } from 'antd';
import Card from "components/card";
import { connect } from "react-redux";
import { getOvertimeList, doOvertimeDelete } from "../../../../redux/overtime/overtimeState";
import CrudOption from "components/dropdown/crudoption";
import OvertimeForm from "./OvertimeForm";
import PopupButton from "components/button/PopupButton";
import { useCRUDAccess } from "utils/useCRUDAccess";
import { DATE_FORMAT, MODULE_OVERTIME, TIME_FORMAT_24HM } from "variables/constants";
import { handleTableChange } from "../../../../utils/index";

const OvertimeTable = ({
	recordList, 
	pagination, 
	doSearch, 
	doDelete,
	filters, 
	doRecordReset,
}) => {
	const checkCRUDAccess = useCRUDAccess();
	const accessRights = checkCRUDAccess(MODULE_OVERTIME, ['view', 'add', 'edit', 'delete'], true);
	console.log(accessRights);

  	const columns = [
		{
	        title: `Employee Name`,
	        dataIndex: 'ots_employee_name',
	        key: 'ots_employee_name',
	        width: '18%',
	        render:(ots_employee_name) => <span>{ots_employee_name}</span> 
	    },
		{
			title: `Date Filed`,
			dataIndex: 'created_at',
			key: 'created_at',
			width: '17%',
			render: (created_at) => (
				<span>{dayjs(created_at).format(`${DATE_FORMAT} ${TIME_FORMAT_24HM}`)}</span>
			)
		},
		{
			title: `Time`,
			key: 'ots_time',
			width: '20%',
			render: (_, record) => (
				<span>
				{`${dayjs(record.ots_date_from).format(`${DATE_FORMAT} ${TIME_FORMAT_24HM}`)} to ${dayjs(record.ots_date_to).format(`${DATE_FORMAT} ${TIME_FORMAT_24HM}`)}`}
				</span>
			)
		},
		{
	        title: <div className="w-full text-right">Hours</div>,
	        dataIndex: 'ots_approved_hours',
	        key: 'ots_approved_hours',
	        width: '10%',
	        render:(ots_approved_hours) => 
				<div className="pr-2 text-right">
					{ots_approved_hours}
				</div> 
	    },
		{
	        title: `Status`,
	        dataIndex: 'ots_status_name',
	        key: 'ots_status_name',
	        width: '10%',
	        render:(ots_status_name) => <span>{ots_status_name}</span> 
	    },	
		{
	        title: `Approved By`,
	        dataIndex: 'approved_by',
	        key: 'approved_by',
	        width: '15%',
	        render:(approved_by) => <span>{approved_by}</span> 
	    },	    
	    {
	        title: <PopupButton id="add_overtime" title="Add Overtime" label="Add" btnClass="btn-small" action="add" moduleId={MODULE_OVERTIME}>
						<OvertimeForm recordId="0" mode="edit"/>
					</PopupButton>,
	        dataIndex: 'ots_id',
	        key: 'ots_id',
	        width: '10%',
	        render:(_, record) => <CrudOption 
											baseRoute="/console/overtimes" 
											recordId={record?.ots_id}
											deleteHandler={doDelete} 
											allowEdit={false}
											allowView={accessRights.edit}
											allowDelete={(accessRights.delete && record.ots_status_id === 63)}
											closeHandler={doRecordReset}
											viewMode="modal"
											title="Edit Overtime"
											viewHandler={(recordId, doRecordReset) => (
												<OvertimeForm 
													recordId={recordId}
													mode="edit"
													onCancel={doRecordReset}
												/>
											)}

										/>
	    },
    ];
    
	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      	
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.ots_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
					onChange={handleTableChange(doSearch, filters)}                  	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.overtime.overtimeList?.items,
	pagination: state.overtime.overtimeList?.pagination,
	filters: state.overtime.overtimeList?.filters,
	requesting: state.overtime.overtimeList?.requesting,
	error: state.overtime.overtimeList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getOvertimeList(filters)),
	doDelete: (id) => dispatch(doOvertimeDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps )(OvertimeTable);
